import React from 'react';

const About = () => {
  return (
    <div className="about">
      <h2 className="about-title">Control Your Focus</h2>
      <p className="about-text">
        I made this app to streamline a daily
        practice of mine... <br /> <br /> Everyday, I select a quote
        which I feel is powerful, from someone I admire,
        and I make that quote the theme of my day. I
        live the quote, for the day. <br /> <br /> This app allows
        the user to select a theme, and a couple of quotes
        related to the theme will be loaded, for the user to
        choose, as the theme for their day.
      </p>
    </div>
  );
}

export default About;
